import { TParsedContent } from "../model/types";

export function parseMessageContent(content: string): TParsedContent {
  try {
    const parsed = JSON.parse(content);
    if (parsed.type === "error") {
      return { type: "error", content: parsed.content || "An error occurred" };
    }
    if (parsed.type === "warning") {
      return { type: "warning", content: parsed.content || content };
    }
    if (parsed.type === "notification") {
      return {
        type: "notification",
        content: parsed.content || "",
        changes: Array.isArray(parsed.changes) ? parsed.changes : [],
        question: typeof parsed.question === "string" ? parsed.question : undefined,
        actionButtons: Array.isArray(parsed.actionButtons) ? parsed.actionButtons : []
      };
    }
    return { type: "answer", content: parsed.content || content };
  } catch {
    return { type: "answer", content };
  }
}
